import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import {
  isArchivedSelector,
  canArchiveSelector,
} from '../../../../data/shippers.js'
import {showArchiveShipperModal} from '../ArchiveShipperModal.js'
import {formSelector, useSelector} from '../../../../store.js'

export default function Archive({formName}) {
  const {id: shipperID} = useSelector((state) =>
    formSelector(state, {formName}),
  )
  const isArchived = useSelector((state) =>
    isArchivedSelector(state, {shipperID}),
  )
  const canArchive = useSelector((state) =>
    canArchiveSelector(state, {shipperID}),
  )

  if (!canArchive) {
    return null
  }

  return (
    <dl className="list">
      <dt className="list__title fs-00 lh-md margin-bottom-5">
        {isArchived ? 'Unarchive' : 'Archive'} Account
      </dt>
      {isArchived ? (
        <dd className="list__item fs-n0 margin-bottom-10">
          Unarchiving this carrier account will give you access again to its
          shipping rates on the Orders page.
        </dd>
      ) : (
        <dd className="list__item fs-n0 margin-bottom-10">
          If you’d like to hide this carrier account from appearing on the
          Orders page, we recommend archiving it. You can always bring it back
          by unarchiving it.
        </dd>
      )}
      <dd className="list__item fs-n0 margin-bottom-0">
        <ButtonPrimary
          size="sm"
          isOutlined
          onClick={() => showArchiveShipperModal(shipperID)}
        >
          {isArchived ? 'Unarchive' : 'Archive'}
        </ButtonPrimary>
      </dd>
    </dl>
  )
}
